import BasicTable from "components/common/table/basicTable/BasicTable"
import { useTranslation } from "react-i18next"
import { visuallyHiddenSx } from "styles/common/typography"

const StoreUpdatesHeader = () => {
  const { t } = useTranslation()
  return (
    <BasicTable.Row>
      <BasicTable.Cell tableCellProps={{ width: "50%" }} minWidth="100px">
        <BasicTable.HeadText>{t("dashboard.item")}</BasicTable.HeadText>
      </BasicTable.Cell>
      <BasicTable.Cell tableCellProps={{ width: "50%" }} minWidth="100px">
        <BasicTable.HeadText>{t("dashboard.classname")}</BasicTable.HeadText>
      </BasicTable.Cell>
      <BasicTable.Cell minWidth="50px">
        <BasicTable.HeadText>{t("dashboard.quantity")}</BasicTable.HeadText>
      </BasicTable.Cell>
      <BasicTable.Cell minWidth="80px" justifyContent="center">
        <BasicTable.HeadText>{t("dashboard.value")}</BasicTable.HeadText>
      </BasicTable.Cell>
      <BasicTable.Cell minWidth="110px">
        <BasicTable.HeadText sx={visuallyHiddenSx}>
          {t("dashboard.actions")}
        </BasicTable.HeadText>
      </BasicTable.Cell>
    </BasicTable.Row>
  )
}

export default StoreUpdatesHeader
